/**
 * Magical function which lives in a world
 * where dividing by `0` returns `0`. Instead
 * of causing a meltdown.
 *
 * @param num Numerator
 * @param den Denominator
 */
export function safeDivide(num, den) {
  if (den === 0) {
    return 0;
  }

  return (num / den);
}
